module.exports = __webpack_public_path__ + "img/garden of the sun.4b68b43d.png";